import { render, staticRenderFns } from "./m-query.vue?vue&type=template&id=badd81f8&scoped=true&"
import script from "./m-query.vue?vue&type=script&lang=js&"
export * from "./m-query.vue?vue&type=script&lang=js&"
import style0 from "./m-query.vue?vue&type=style&index=0&id=badd81f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badd81f8",
  null
  
)

export default component.exports